export default "__VITE_ASSET__m9J9xweJ__"